// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w6Bvu{display:inline-block}.ImMrI{width:100%}.uH61R{flex:1;text-align:center;border:1px solid #c4cdd5;border-right-width:0}.uH61R:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}.uH61R:last-child{border-right-width:1px;border-top-right-radius:3px;border-bottom-right-radius:3px}._1hx2n{display:flex;width:100%}\n", ""]);
// Exports
exports.locals = {
	"root": "w6Bvu",
	"fluid": "ImMrI",
	"radio": "uH61R",
	"wrapper": "_1hx2n"
};
module.exports = exports;
